module.exports = __webpack_public_path__ + "img/desktop.247b061.webp";